import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navigation from "./Navigation";
import Footer from "./Footer";
import { scrollToTop } from "@/lib/utils";

const Layout: React.FC = () => {
  const location = useLocation();

  const isBlueNavbarLinks = [
    "/",
    "/home",
    "/about",
    "/pricing",
    "/clients",
  ];
  const isBlueNavbar =
    isBlueNavbarLinks.includes(location.pathname) ||
    location.pathname.startsWith("/blog");

  // Scroll to top on route change
  useEffect(() => {
    scrollToTop(false);
  }, [location.pathname]);

  return (
    <div className="flex flex-col min-h-screen">
      <Navigation isLightHeader={!isBlueNavbar} />
      <main className="grow">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
